export default {
  leftFace: {
    id: 0,
    color: [110, 64, 170],
  },
  rightFace: {
    id: 1,
    color: [143, 61, 178],
  },
  leftUpperArmFront: {
    id: 2,
    color: [178, 60, 178],
  },
  leftUpperArmBack: {
    id: 3,
    color: [210, 62, 167],
  },
  rightUpperArmFront: {
    id: 4,
    color: [238, 67, 149],
  },
  rightUpperArmBack: {
    id: 5,
    color: [255, 78, 125],
  },
  leftLowerArmFront: {
    id: 6,
    color: [255, 94, 99],
  },
  leftLowerArmBack: {
    id: 7,
    color: [255, 115, 75],
  },
  rightLowerArmFront: {
    id: 8,
    color: [255, 140, 56],
  },
  rightLowerArmBack: {
    id: 9,
    color: [239, 167, 47],
  },
  leftHand: {
    id: 10,
    color: [217, 194, 49],
  },
  rightHand: {
    id: 11,
    color: [194, 219, 64],
  },
  torsoFront: {
    id: 12,
    color: [175, 240, 91],
  },
  torsoBack: {
    id: 13,
    color: [135, 245, 87],
  },
  leftUpperLegFront: {
    id: 14,
    color: [96, 247, 96],
  },
  leftUpperLegBack: {
    id: 15,
    color: [64, 243, 115],
  },
  rightUpperLegFront: {
    id: 16,
    color: [40, 234, 141],
  },
  rightUpperLegBack: {
    id: 17,
    color: [28, 219, 169],
  },
  leftLowerLegFront: {
    id: 18,
    color: [26, 199, 194],
  },
  leftLowerLegBack: {
    id: 19,
    color: [33, 176, 213],
  },
  rightLowerLegFront: {
    id: 20,
    color: [47, 150, 224],
  },
  rightLowerLegBack: {
    id: 21,
    color: [65, 125, 224],
  },
  leftFoot: {
    id: 22,
    color: [84, 101, 214],
  },
  rightFoot: {
    id: 23,
    color: [99, 81, 195],
  },
};
